import { Injectable, signal, inject } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { SidebarComponent } from '../partials';
import {
  MENU_ITEMS_INJECTION,
  PAGE_ROUTES_INJECTION,
} from '../constants/ui-constant';
import { LOCAL_STORAGE } from '@core-utils';

@Injectable()
export class LayoutService {
  private offcanvasService = inject(NgbOffcanvas);
  private PAGE_ROUTES = inject<{
    [key: string]: string;
  }>(PAGE_ROUTES_INJECTION);
  private menuItems = inject(MENU_ITEMS_INJECTION);

  private readonly SIDEBAR_MINIMIZE_ATTR = LOCAL_STORAGE.SIDEBAR_MINIMIZE_ATTR;
  private readonly MOBILE_OFFCANVAS_CLASS =
    LOCAL_STORAGE.MOBILE_OFFCANVAS_CLASS;
  private readonly LOCAL_STORAGE_KEY = LOCAL_STORAGE.SIDEBAR_MINIMIZE_STATE;
  initialMenuState = this.getInitialMenuState();
  sidebarMinimized$ = new BehaviorSubject<boolean>(this.initialMenuState);
  sidebarMinimizedState = signal<boolean>(this.getInitialMenuState());

  constructor() {
    this.setInitialSidebarState();
  }

  toggleSidebarMinimize(): void {
    const bodyElement = document.body;
    const currentState = bodyElement.getAttribute(this.SIDEBAR_MINIMIZE_ATTR);
    const newState = currentState === 'on' ? 'off' : 'on';
    this.sidebarMinimized$.next(newState === 'on');
    this.sidebarMinimizedState.set(newState === 'on');
    bodyElement.setAttribute(this.SIDEBAR_MINIMIZE_ATTR, newState);
    localStorage.setItem(this.LOCAL_STORAGE_KEY, newState);

    const sidebar = document.querySelector('.app-sidebar') as HTMLElement;
    if (sidebar) {
      sidebar.style.pointerEvents = 'none';
      setTimeout(() => {
        sidebar.style.pointerEvents = '';
      }, 300);
    }
  }

  openMobileMenu() {
    const offcanvasRef = this.offcanvasService.open(SidebarComponent, {
      panelClass: this.MOBILE_OFFCANVAS_CLASS,
    });
    offcanvasRef.componentInstance.PAGE_ROUTES.set(this.PAGE_ROUTES);
    offcanvasRef.componentInstance.menuItems.set(this.menuItems);
  }

  private getInitialMenuState(): boolean {
    const savedState = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    return savedState === 'on';
  }

  private setInitialSidebarState(): void {
    const bodyElement = document.body;
    const savedState = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    if (savedState) {
      bodyElement.setAttribute(this.SIDEBAR_MINIMIZE_ATTR, savedState);
    }
  }
}
